<template>
  <div :id="id" class="sk-code-editor"></div>
</template>

<script>
import utils from '../../mixins/utils';

export default {
  name: 'code-editor',
  mixins: [utils],
  props: {
    content: {
      type: String,
      required: false,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      required: false,
      default: 'html',
    },
    lineNumbers: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  computed: {
    cleanedContent() {
      return this.stripSlashes(this.content);
    },
  },
  methods: {
    initializeEditor() {
      this.editor = new CodeFlask(`#${this.id}`, {
        language: this.language,
        lineNumbers: this.lineNumbers,
      });
      this.editor.updateCode(this.cleanedContent);
      this.editor.onUpdate(code => this.$emit('content-change', code));
    },
  },
  watch: {
    cleanedContent(content) {
      if (this.editor) {
        this.editor.updateCode(this.cleanedContent);
      }
    },
  },
  mounted() {
    this.initializeEditor();
  },
};
</script>

<style lang="scss">
.sk-code-editor {
  min-height: 256px;
  position: relative;

  pre {
    background: none;
    border: 0;
  }

  textarea {
    border: 1px solid #cccccc;
  }
}
</style>
